/**
 * Formate un montant en devise
 * @param {number} amount - Le montant à formater
 * @param {string} currency - Le code de la devise (ex: 'EUR', 'USD')
 * @returns {string} Le montant formaté
 */
export const formatCurrency = (amount, currency) => {
  // Vérifier que currency est valide
  if (!currency || typeof currency !== 'string') {
    currency = 'EUR'; // Valeur par défaut
  }
  
  // Vérifier que amount est un nombre valide
  const numAmount = Number(amount);
  if (isNaN(numAmount)) {
    return `0 ${currency}`;
  }
  
  try {
    const formatter = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return formatter.format(numAmount);
  } catch (error) {
    // En cas d'erreur, retourner un format simple
    return `${numAmount.toLocaleString('fr-FR')} ${currency}`;
  }
};

/**
 * Formate un montant simple sans devise
 * @param {number} amount - Le montant à formater
 * @returns {string} Le montant formaté
 */
export const formatAmount = (amount) => {
  const numAmount = Number(amount);
  if (isNaN(numAmount)) {
    return '0';
  }
  
  return numAmount.toLocaleString('fr-FR');
};

